/**
 * MODULE: _shared/frontend-shell/src/layout/mobileShell/useMobileShellState.ts
 * PURPOSE: Shared reactive mobile-shell state for provider and hooks.
 * PUBLIC_API: useMobileShellState
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 45 / 100
 */

import { useEffect, useState } from 'react';

import {
  MOBILE_SHELL_MEDIA_QUERIES,
  readMobileShellActive,
  readNarrowViewport,
} from './mobileShellDetection';
import type { MobileShellContextValue } from './MobileShellProvider';

function readShellState(): MobileShellContextValue {
  return {
    isNarrowViewport: readNarrowViewport(),
    isMobileShell: readMobileShellActive(),
  };
}

export function useMobileShellState(): MobileShellContextValue {
  const [state, setState] = useState<MobileShellContextValue>(readShellState);

  useEffect(() => {
    const refresh = () => setState(readShellState());
    refresh();

    const mediaLists = MOBILE_SHELL_MEDIA_QUERIES.map((query) =>
      window.matchMedia(query)
    );
    for (const mq of mediaLists) {
      mq.addEventListener('change', refresh);
    }
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('orientationchange', refresh);

    return () => {
      for (const mq of mediaLists) {
        mq.removeEventListener('change', refresh);
      }
      window.removeEventListener('resize', refresh);
      window.removeEventListener('orientationchange', refresh);
    };
  }, []);

  return state;
}
